var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_920_1094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72647 12.3776C3.42655 12.6776 3.42043 13.2101 3.73259 13.5222C4.05088 13.8344 4.5834 13.8283 4.8772 13.5345L8.50076 9.91093L12.1182 13.5284C12.4243 13.8344 12.9507 13.8344 13.2628 13.5222C13.575 13.204 13.575 12.6837 13.2689 12.3776L9.65149 8.7602L13.2689 5.13664C13.575 4.8306 13.5811 4.3042 13.2628 3.99204C12.9507 3.67987 12.4243 3.67987 12.1182 3.98591L8.50076 7.60336L4.8772 3.98591C4.5834 3.68599 4.04476 3.67375 3.73259 3.99204C3.42043 4.3042 3.42655 4.84284 3.72647 5.13664L7.34392 8.7602L3.72647 12.3776Z",
    fill: "#434343",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_920_1094",
    x: -53.8656,
    y: -53.6085,
    width: 124.731,
    height: 124.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27.1828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_920_1094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_920_1094",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelUploadIcon);
export default __webpack_public_path__ + "static/media/cancelUploadIcon.e043b554febeb7485db3e5afaf4b0046.svg";
export { ForwardRef as ReactComponent };